import type { ThreatGroupScores } from '@types';

type MapScoreDetails = Omit<ThreatGroupScores, 'confidence'> & {
    confidence?: ThreatGroupScores['confidence'] | number | string | null;
    methodology?: string;
};

export function threatGroupMapDetails(item: MapScoreDetails) {
    const confidence = item.confidence && typeof item.confidence === 'object'
        ? item.confidence : { score: item.confidence, justification: item.confidenceJustification };
    return {
        confidence: { ...confidence, justification: confidence.justification || item.confidenceJustification
            || 'No evidence-based confidence assessment exists for this dossier item.' },
        methodology: item.riskJustification || item.methodology || 'No supported risk estimate exists for this dossier item.',
        ...(item.scoreEvidence?.length ? { vettingSources: item.scoreEvidence } : {})
    };
}
